export default [
  "Starter",
  "Route 1 (Gras)",
  "Route 2 (Gras)",
  "Vertania-Wald (Gras)",
  "Route 3 (Gras)",
  "Route 24 (Im Pokecenter kaufen)",
  "Mondberg (Höhle)",
  "Route 4 (Gras)",
  "Azuria City (Tausch: Jurob für Quapsel)",
  "Route 24 (Gras)",
  "Route 25 (Gras)",
  "Route 5 (Gras)",
  "Route 6 (Gras)",,
  "Route 11 (Gras)",
  "Digda-Höhle (Höhle)",
  "Route 9 (Gras)",
  "Route 10 (Gras)",
  "Kraftwerk (Gebäude/Innen)",
  "Felstunnel (Höhle)",
  "Lavandia (Tausch)",
  "Pokémon-Turm (Innen)",
  "Route 8 (Gras)",
  "Route 7 (Gras)",
  "Route 12 (Gras)",
  "Route 13 (Gras)",
  "Route 14 (Gras)",
  "Route 15 (Gras)",
  "Route 16 (Gras)",
  "Route 17 (Gras)",
  "Route 18 (Gras)",
  "Safari-Zone (Gras, Teiche)",
  "Fuchsania City (Angeln)",
  "Route 19 (Angeln)",
  "Route 20 (Angeln)",
  "Zinnoberinsel (Angeln)",
  "Seeschauminseln (Höhle)",
  "Pokémon-Haus (Innen)",
  "Mewtu-Höhle (Höhle)",
  "Route 21 (Angeln)",
  "Siegesstraße (Höhle)",
  "Fossil-1",
  "Fossil-2",
  "Fossil-3",
  "Fossil-4",
  "Fossil-5",
  "Extra-1",
  "Extra-2",
  "Extra-3",
  "Extra-4",
  "Extra-5",
  "Shiny",
  "Mistmon of the Year"
];